import {doGet, doPost} from './Base';


const getAccount = async () => {
  const url = '/account';
  return await doGet(url);
};

const getAccounts = async () => {
  const url = '/accounts';
  return await doGet(url);
};

const setAccount = async (account_id) => {
  const url = '/change_account/' + account_id;
  return await doPost(url, {});
};

const unsetAccount = async () => {
  const url = '/unchange_account';
  return await doPost(url, {});
};


export {getAccount, getAccounts, setAccount, unsetAccount};
export default getAccounts;
